import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../../routes/routeConfig';

interface SectionContent {
    number: string;
    title: string;
    paragraphs: string[];
    listItems?: string[];
}

const termsSections: SectionContent[] = [
    {
        number: '1',
        title: 'Introducción',
        paragraphs: [
            'Este documento establece los Términos y Condiciones de uso de la aplicación CICLII., diseñada para el registro del periodo menstrual en niñas desde los 9 años. El uso de este Sitio Web implica la aceptación plena de los términos aquí descritos.',
        ],
    },
    {
        number: '2',
        title: 'Aceptación de los Términos',
        paragraphs: ['Al acceder y utilizar este sitio Web, usted acepta cumplir con estos Términos y Condiciones. Si no está de acuerdo con alguno de los términos, le recomendamos no utilizar el sitio Web.'],
    },
    {
        number: '3',
        title: 'Descripción del Servicio',
        paragraphs: [
            'El Sitio Web permite a las usuarias registrar información relacionada con su ciclo menstrual, incluyendo fechas, síntomas y observaciones. Está dirigida exclusivamente a niñas desde los 9 años, bajo supervisión y consentimiento de sus padres o tutores legales.',
        ],
    },
    {
        number: '4',
        title: 'Requisitos de Uso',
        paragraphs: [
            'El uso de la aplicación está condicionado a la autorización expresa de los padres o tutores legales de las menores. No se permite el uso por parte de personas mayores de edad ni menores sin supervisión.',
        ],
    },
    {
        number: '5',
        title: 'Protección de Datos Personales',
        paragraphs: [
            'La aplicación cumple con la Ley 19.628 sobre Protección de la Vida Privada en Chile. Los datos recolectados serán tratados de forma confidencial, almacenados de manera segura y utilizados únicamente para los fines establecidos.',
        ],
    },
    {
        number: '6',
        title: 'Limitación de Responsabilidad',
        paragraphs: [
            'La aplicación no sustituye el asesoramiento médico profesional. Los desarrolladores no se responsabilizan por decisiones tomadas en base a la información registrada en la plataforma.',
        ],
    },
    {
        number: '7',
        title: 'Propiedad Intelectual',
        paragraphs: [
            'Todos los derechos sobre el contenido, diseño y funcionalidades de la aplicación pertenecen a sus desarrolladores. Está prohibida la reproducción o distribución sin autorización previa.',
        ],
    },
    {
        number: '8',
        title: 'Modificaciones a los Términos',
        paragraphs: [
            'Los desarrolladores se reservan el derecho de modificar estos Términos y Condiciones en cualquier momento. Las actualizaciones serán notificadas a través de la aplicación.',
        ],
    },
    {
        number: '9',
        title: 'Jurisdicción y Ley Aplicable',
        paragraphs: [
            'Estos Términos se rigen por las leyes de la República de Chile. Cualquier controversia será resuelta por los tribunales competentes del país.',
        ],
    },
    {
        number: '10',
        title: 'Política de Privacidad',
        paragraphs: [
            'Para más información sobre el tratamiento de datos personales, consulte nuestra Política de Privacidad disponible en la aplicación.',
        ],
    },
];

const privacySections: SectionContent[] = [
    {
        number: '1',
        title: 'Introducción',
        paragraphs: [
            'La presente Política de Privacidad describe cómo el Sitio web Ciclii, destinada al registro del periodo menstrual en niñas desde los 9 años, recopila, utiliza, almacena y protege la información personal de sus usuarias.',
        ],
    },
    {
        number: '2',
        title: 'Tipo de Datos Recolectados',
        paragraphs: ['La aplicación puede recopilar los siguientes datos personales:'],
        listItems: [
            'Nombre o Nickname (apodo) y edad de la usuaria.',
            'Dirección de correo electrónico.',
            'Fechas del ciclo menstrual y síntomas asociados.',
            'Autorización del tutor legal (si aplica).',
        ],
    },
    {
        number: '3',
        title: 'Finalidad del Tratamiento de Datos',
        paragraphs: [
            'Los datos recolectados serán utilizados exclusivamente para el seguimiento del ciclo menstrual de las usuarias, con el objetivo de brindar información útil sobre su salud y desarrollo.',
        ],
    },
    {
        number: '4',
        title: 'Consentimiento Parental',
        paragraphs: [
            'El uso de la aplicación por parte de menores de edad requiere el consentimiento expreso de sus padres o tutores legales. Este consentimiento debe ser otorgado en el registro de la página.',
        ],
    },
    {
        number: '5',
        title: 'Almacenamiento y Seguridad de los Datos',
        paragraphs: [
            'Los datos personales serán almacenados en servidores seguros y protegidos mediante medidas técnicas y organizativas adecuadas para evitar accesos no autorizados, pérdida o alteración de la información.',
        ],
    },
    {
        number: '6',
        title: 'Derechos de los Usuarios',
        paragraphs: [
            'Los usuarios y sus tutores legales tienen derecho a acceder, rectificar, eliminar y oponerse al tratamiento de sus datos personales. Para ejercer estos derechos, pueden contactar al responsable de la aplicación.',
        ],
    },
    {
        number: '7',
        title: 'Compartición de Datos con Terceros',
        paragraphs: [
            'El sitio Web no compartirá los datos personales con terceros, salvo en los casos exigidos por ley o con el consentimiento explícito del tutor legal.',
        ],
    },
    {
        number: '8',
        title: 'Retención y Eliminación de Datos',
        paragraphs: [
            'Los datos personales serán conservados únicamente durante el tiempo necesario para cumplir con la finalidad para la cual fueron recolectados. Posteriormente, serán eliminados de forma segura.',
        ],
    },
    {
        number: '9',
        title: 'Modificaciones a la Política de Privacidad',
        paragraphs: [
            'Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. Las actualizaciones serán notificadas a través del sitio Web.',
        ],
    },
    {
        number: '10',
        title: 'Contacto',
        paragraphs: [
            'Para cualquier consulta relacionada con esta Política de Privacidad o el tratamiento de datos personales, puede contactarnos a través del correo electrónico proporcionado en el sitio Web.',
        ],
    },
];


const TermsAndConditions: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const initialView: 'terms' | 'privacy' = location.pathname === routes.public.privacy ? 'privacy' : 'terms';
    const [activeView, setActiveView] = useState<'terms' | 'privacy'>(initialView);

    const handleGoBack = () => {
        if (typeof window !== 'undefined' && window.history.length > 1) {
            navigate(-1);
            return;
        }
        navigate(routes.public.login);
    };


    useEffect(() => {
        const newView = location.pathname === routes.public.privacy ? 'privacy' : 'terms';
        setActiveView(prev => (prev === newView ? prev : newView));
    }, [location.pathname]);

    const sectionsToRender = activeView === 'terms' ? termsSections : privacySections;
    const headerTitle = activeView === 'terms' ? 'Términos y Condiciones de Uso' : 'Política de Privacidad – Sitio Web Ciclii';
    const lastUpdatedText = 'Última actualización: Noviembre de 2025';
    const footerText =
        activeView === 'terms'
            ? 'Para consultas sobre los Términos y Condiciones, contáctanos en soporte@ciclii.com'
            : 'Para consultas sobre la Política de Privacidad, contáctanos en soporte@ciclii.com';

    const renderSection = (section: SectionContent) => (
        <section key={section.number} className='terms-section'>
            <h2>
                <span className='terms-section-number'>{section.number}</span>
                <span>{section.title}</span>
            </h2>
            {section.paragraphs.map((paragraph, index) => (
                <p key={`${section.number}-p-${index}`}>{paragraph}</p>
            ))}
            {section.listItems && (
                <ul>
                    {section.listItems.map((item, index) => (
                        <li key={`${section.number}-li-${index}`}>{item}</li>
                    ))}
                </ul>
            )}
        </section>
    );

    const handleSwitchView = (view: 'terms' | 'privacy') => {
        if (view === activeView) {
            return;
        }
        setActiveView(view);
        const targetRoute = view === 'terms' ? routes.public.terms : routes.public.privacy;
        navigate(targetRoute);
    };

    return (
        <div className='terms-main-wrapper'>
            <div className='terms-header-top'>
                <button type='button' className='terms-back-button' onClick={handleGoBack}>
                    <FaArrowLeft /> Volver
                </button>
            </div>
            <div className='terms-container'>
                <header className='terms-header'>
                    <h1>{headerTitle}</h1>
                    <p>{lastUpdatedText}</p>
                    {/* <div className='terms-toggle'>
                        <button
                            type='button'
                            className={`btn ${activeView === 'terms' ? 'btn-primary' : 'btn-secondary'}`}
                            onClick={() => handleSwitchView('terms')}
                        >
                            Términos y Condiciones
                        </button>
                        <button
                            type='button'
                            className={`btn ${activeView === 'privacy' ? 'btn-primary' : 'btn-secondary'}`}
                            onClick={() => handleSwitchView('privacy')}
                        >
                            Política de Privacidad
                        </button>
                    </div> */}
                </header>

                <main className='terms-content'>
                    {sectionsToRender.map(renderSection)}
                </main>

                <footer className='terms-footer'>
                    <p>{footerText}</p>
                </footer>
            </div>
        </div>
    );
};

export default TermsAndConditions;
